import { ArrowRight } from "lucide-react";

import { Reveal, RevealStagger, RevealItem } from "@/components/Reveal";
import { INDUSTRIES } from "@/lib/site";
export default function IndustriesSection () {
     return (
        
      <section data-testid="industries-section" className="relative py-24 md:py-36 bg-[#F6F7F5]">
       {/* INDUSTRIES SERVED */}
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="overline text-stenzia-green"><span className="kbd-line" /> Industries We Serve</div>
            <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-[60px] tracking-tighter text-charcoal leading-[1.02] max-w-4xl">
              Trusted by the people who define <span className="italic text-stenzia-green">how tiles are sold.</span>
            </h2>
          </Reveal>

          <RevealStagger className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {INDUSTRIES.map((i, idx) => (
              <RevealItem key={i.title}>
                <div data-testid={`industry-${i.title.toLowerCase().replace(/\s+/g, "-")}`} className="group relative h-full bg-white rounded-3xl p-8 md:p-10 border border-transparent hover:border-stenzia-green/20 hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 overflow-hidden">
                  <div className="absolute -bottom-10 -right-10 w-32 h-32 rounded-full bg-stenzia-gold/0 group-hover:bg-stenzia-gold/10 transition-all duration-700" />
                  <div className="relative">
                    <div className="font-display text-stenzia-gold/70 text-xs font-semibold tracking-[0.3em]">0{idx + 1}</div>
                    <div className="mt-3 flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-stenzia-green" />
                      <h3 className="font-display text-lg md:text-xl text-charcoal tracking-tight">{i.title}</h3>
                    </div>
                    <p className="mt-4 text-sm text-charcoal/65 leading-relaxed">{i.body}</p>
                    <div className="mt-6 inline-flex items-center gap-1 text-stenzia-green text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      Learn more <ArrowRight size={14} />
                    </div>
                  </div>
                </div>
              </RevealItem>
            ))}
          </RevealStagger>
        </div>
      </section>
    
     );
}